import React, { FC, ReactNode } from "react";
import FlowioErrorBoundary, { ErrorBoundaryProps } from "./FlowioErrorBoundary";
import {
  useInvokeBugReportModalCallback,
  usePushErrorToStackCallback,
} from "../../../store/bugReport/useActions";
import { BugModalInvoker } from "../../../store/bugReport/types";

const Container: FC<Props> = ({ children, ...rest }) => {
  const { ErrorBoundary } = BugModalInvoker;
  const invokeModal = useInvokeBugReportModalCallback(ErrorBoundary);
  const usePushErrorToStack = usePushErrorToStackCallback(ErrorBoundary);

  return (
    <FlowioErrorBoundary
      {...rest}
      invokeBugReportModal={invokeModal}
      pushErrorToBugReportStack={usePushErrorToStack}
    >
      {children}
    </FlowioErrorBoundary>
  );
};

export type Props = Omit<
  ErrorBoundaryProps,
  "invokeBugReportModal" | "pushErrorToBugReportStack"
> & {
  children: ReactNode;
};

export default Container;
export type ContainerProps = Props;
